import React from 'react';
import { PrivacyPolicyPage } from '../layouts/PrivacyPolicyPage';

const Page = () => <PrivacyPolicyPage />;
export default Page;
